import React from 'react';
import './notfound.css';

class NotFoundPage extends React.Component {
  render() {
    return(
      <div className='NotFoundPage-container'>
        <main className='NotFoundPage-content'>
          <h1 className='NotFoundPage-code'>404</h1>
          <p className='NotFoundPage-title'>Page Not Found</p>
          <p className='NotFoundPage-text'>
            The page you&apos;re looking for does not exist or an another error occurred.
          </p>
          <p className='NotFoundPage-text'>
            Return to the home page to choose a new direction.
          </p>
        </main>
      </div>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/routes/notfound/notfound.js